import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

export const LIVE_LIST_NAMES = {
	PRODUCTS_BY_ITEM_NUMBER: 'products-by-item-number',
	PRODUCTS_BY_CUSTOMER_ITEM_NUMBER: 'products-by-customer-item-number',
	CUSTOMER_SHIP_TO_LOCATIONS: 'customer-ship-to-locations',
	CUSTOMER_SHIP_TO_ADDRESSES: 'customer-ship-to-addresses',
	EMAIL_TEMPLATES: 'email-templates',
	PLANTS: 'plants',
};

/**
 * Hook for accessing LiveList API methods.
 *
 * Usage:
 * const { get, cancel } = useLiveListApi();
 * await get({ listName, filters });
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useLiveListApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			get: ({ listName, filters }) =>
				call({
					url: API_URLS.liveList.get({ listName }),
					method: API_METHODS.POST,
					payload: filters,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
